import eventBus from '@/utils/eventBus'

function gotoView(data, responseCallback) { // 原生调用js函数执行页面返回
  window.location.href = data
}

function nativeCallback(functionName, id, params) { // 安卓回调
  window.nativeCallback[functionName + id](params)
}

function pdaScan(params) { // 安卓扫码
  eventBus.$emit('pdaScan', params)
}

function rfidTagRead(epcTid) {
  alert(epcTid)
}
// 初始化，启动监听原生事件
const nativeBridgeInit = function () {
  // IOS链接桥
  function setupWebViewJavascriptBridge (callback) {
    if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge) }
    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback) }
    window.WVJBCallbacks = [callback]
    const WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'https://__bridge_loaded__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
  }
  setupWebViewJavascriptBridge(function(bridge) {
    // 次函数提供给原生调用执行，data为传过来的参数，responseData是返回的参数
    bridge.registerHandler('gotoView', function(data, responseCallback) {
      gotoView(data, responseCallback)
    })
    bridge.registerHandler('nativeCallback', function(data, responseCallback) {
      nativeCallback(data, responseCallback)
    })
  })
}

// 调用原生方法
const nativeBridgeCall = function(functionName, param = {}, callback = function() { return 0 }) {
  window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler(functionName, param, function(response) { callback(response) })
  if (window.android) {
    window.nativeCallback = window.nativeCallback || {}
    const id = new Date().getTime().toString()
    window.nativeCallback[functionName + id] = callback
    try {
      const json = typeof param === 'string' ? param : JSON.stringify(param)
      window.android[functionName](id, json)
    } catch (e) {
      console.warn(`原生函数[${functionName}]调用无效`)
    }
  }
}

window.windowNativeBridge = {
  gotoView: gotoView,
  nativeCallback: nativeCallback,
  pdaScan: pdaScan
}

export { nativeBridgeCall, nativeBridgeInit }
